import {Injectable} from '@angular/core';
import {Backend} from '@generated-backend-types';
import Patient = Backend.App.Resources.Dashboard.Patient;
import {BaseEndpointService} from '../base-endpoint-service';
import {ListItem} from '../../../entities/list-item.entity';
import PatientData = Backend.App.Data.Dashboard.PatientData;

@Injectable({providedIn: 'root'})
export class PatientService extends BaseEndpointService<Patient, PatientData> {
  protected override endpoint = '/patients';

  public override modelToMultiSelectItem(m: Patient): ListItem & { model: Patient; } {
    return {
      id: m.id,
      text: m.first_name + ' ' + m.last_name,
      isDisabled: false,
      model: m,
    }
  }
}
